var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKlevuOnboardingEpLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7529 33.695C39.3491 37.7049 39.3948 42.2419 37.7987 46.2517L50.2872 46.2141V33.699L37.7529 33.695Z",
    fill: "#2BCC7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7525 33.6951L46.6128 24.8496L37.7429 16L29.8555 23.8694L33.9819 27.9864C35.6667 29.6674 36.9245 31.618 37.7525 33.6951Z",
    fill: "#2BCC7E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9819 51.9269L29.8555 56.0438L37.7429 63.9132L46.6128 55.0636L37.7982 46.2518C36.9702 48.3288 35.6667 50.2458 33.9819 51.9269Z",
    fill: "#2BCC7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlevuOnboardingEpLogo);
export default __webpack_public_path__ + "static/media/klevu-onboarding-ep-logo.80a1c454fd7f34b61dbee1c6bdf822ba.svg";
export { ForwardRef as ReactComponent };